import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { Layout } from './Layout';
import { Home } from './components/Home';

export default class App extends Component {

  render () {
    return (
      <Layout>
        <Route exact path='/' component={Home} />
      </Layout>
    );
  }
}
